module.exports = __webpack_public_path__ + "static/media/sidemenu-user.35bd456d.svg";